export default __webpack_public_path__ + "static/assets/med_capsule_H_solid_01_m.e2d66201.png";